import * as React from "react";
import { List, Button, Box, ListItem, Typography } from "@mui/material";
import { getPresenzeCantiere } from "../../service/cantieri";
import { useSnackbar } from "notistack";
import LoadingView from "../../components/LoadingView";
import ItemOperatore from "./ItemOperatore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
type TypeOperatore = {

    idoperatorecantiere: string; 
    idcantiere: string; 
    nomecognome: string; 

}

type TypeData = {

    logo_cantiere: string; 
    operatori_presenti: Array<TypeOperatore>;

}

type TypeResult = {

    status: "success" | "error"; 
    message: string; 
    data: TypeData; 

}; 

const Cantiere = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { state } : { state : any } = useLocation();

  const [results, setResults] = React.useState<TypeData | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {

    if(!state?.cantiere) {

      navigate("/");
  
    }

    if (!id) {

        navigate("/");
       
    } else {
        
        scaricaPresenze(); 

    }

  }, [id]);

  const scaricaPresenze = async () => {

    try {

        const result: TypeResult = await getPresenzeCantiere(id);

        if(result) {

            setResults(result.data);
            setIsLoading(false);

        } else {

            navigate("/");

        }

    } catch(e: any) {

        enqueueSnackbar(e.message ? e.message : e, { variant: "error" });
        navigate("/"); 

    }
 
  }

  return (
    <Box>
      <Button onClick={() => {

      navigate(-1); 

      }} variant="contained" sx={{mb:2}} startIcon={<ArrowBackIcon />}>Torna indietro</Button>
      {isLoading === true ? (
        <List>
          <ListItem alignItems="flex-start">
            <LoadingView />
          </ListItem>
        </List>
      ) : (
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
          <ListItem>
            <img src={state.cantiere.logo_cantiere} style={{width:100, background: '#fff', borderRadius: 5, padding: 5, marginRight: 10}} />
            <Typography >
              {state.cantiere.nomecantiere}
            </Typography>
          </ListItem>
          {results && results.operatori_presenti.map((result, key) => (
            <ItemOperatore key={key} operatore={result} />
          ))}
        </List>
      )}
    </Box>
  );
};

export default Cantiere;
